module.exports = __webpack_public_path__ + "img/img-personaliza.2a6019de.png";